import axios from '../../plugins/axios';

/**
 * Доработка заявки MyCar: досылаем банку документ и комментарий менеджера.
 *
 * Через plugins/api нельзя: там всегда Content-Type application/json, и поля
 * формы до бэка не доходят — appealId приходил пустым, и ответом было
 * «Заявка MyCar не найдена». Файлы у нас везде уходят так же, через axios.
 */
const sendMyCarUpdate = ({ appealId, comment, documentType, file }) => {
  const form = new FormData();
  form.append('appealId', appealId);
  if (comment) form.append('comment', comment);
  if (documentType) form.append('documentType', documentType);
  if (file) form.append('file', file);
  return axios.post('/crm/creditPlatform/mycar/updateApplication', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export default sendMyCarUpdate;
